import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Rx'
import { upload, validate } from 'store/services/vouchers'
import { alertSuccess, alertErrorDefault } from 'store/ducks/alert'
import * as profileDuck from 'store/ducks/profile'
import * as authenticationDuck from 'store/ducks/authentication'
import { intl } from 'i18n'

// Actions
export const VOUCHERS_REQUEST = 'vouchers/VOUCHERS_REQUEST'
export const VOUCHERS_SUCCESS = 'vouchers/VOUCHERS_SUCCESS'
export const VOUCHERS_FAILURE = 'vouchers/VOUCHERS_FAILURE'
export const VALIDATION_REQUEST = 'vouchers/VALIDATION_REQUEST'
export const VALIDATION_SUCCESS = 'vouchers/VALIDATION_SUCCESS'
export const VALIDATION_FAILURE = 'vouchers/VALIDATION_FAILURE'

// Reducer
const INITIAL = {
  upload: {
    loading: false,
    uploaded: false,
    errors: [],
  },
  validation: {
    loading: false,
    validated: false,
    errors: [],
  },
}

export function reducer(state = INITIAL, action = {}) {
  switch (action.type) {
    case VOUCHERS_REQUEST:
      return {
        ...state,
        upload: {
          loading: true,
          uploaded: false,
          errors: [],
        },
      }

    case VOUCHERS_SUCCESS:
      return {
        ...state,
        upload: {
          loading: false,
          uploaded: true,
          errors: [],
        },
      }

    case VOUCHERS_FAILURE:
      return {
        ...state,
        upload: {
          loading: false,
          uploaded: false,
          errors: action.errors,
        },
      }

    case VALIDATION_REQUEST:
      return {
        ...state,
        validation: {
          loading: true,
          validated: false,
          errors: [],
        },
      }

    case VALIDATION_SUCCESS:
      return {
        ...state,
        validation: {
          loading: false,
          validated: true,
          errors: [],
        },
      }

    case VALIDATION_FAILURE:
      return {
        ...state,
        validation: {
          loading: false,
          validated: false,
          errors: action.errors,
        },
      }

    default:
      return state
  }
}

// Actions Creators
export const vouchersRequest = (raw) => ({
  type: VOUCHERS_REQUEST,
  payload: Object.keys(raw).reduce(
    (obj, key) =>
      Object.assign(
        obj,
        raw[key] && raw[key].size
          ? {
              [key]: raw[key],
            }
          : {},
      ),
    {},
  ),
})

export const vouchersSuccess = () => ({
  type: VOUCHERS_SUCCESS,
})

export const vouchersFailure = (errors) => ({
  type: VOUCHERS_FAILURE,
  errors,
})

export const validationRequest = () => ({
  type: VALIDATION_REQUEST,
})

export const validationSuccess = () => ({
  type: VALIDATION_SUCCESS,
})

export const validationFailure = (errors) => ({
  type: VALIDATION_FAILURE,
  errors,
})

// Epics
export const epic = combineEpics(
  vouchersRequestEpic,
  validationRequestEpic,
  sendAlertOnfailureEpic,
  sendAlertOnVoucherSuccessEpic,
)

export function vouchersRequestEpic(action$) {
  return action$.ofType(VOUCHERS_REQUEST).mergeMap((action) =>
    Observable.ajax(upload({ payload: action.payload }))
      .mergeMap((res) => Observable.of(vouchersSuccess(), profileDuck.fetchSuccess(res.response), validationRequest()))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(vouchersFailure(errors))
        } catch (e) {
          return Observable.of(vouchersFailure([]))
        }
      }),
  )
}

export function validationRequestEpic(action$) {
  return action$.ofType(VALIDATION_REQUEST).mergeMap((action) =>
    Observable.ajax(validate())
      .mergeMap((res) => Observable.of(validationSuccess(), profileDuck.fetchSuccess(res.response)))
      .catch((err) => {
        if (typeof err === 'object' && (err.response || {}).code === 401) {
          return Observable.of(authenticationDuck.refreshTokenRequest(action))
        }

        try {
          const errors = [...(err.response.violations || []), ...(err.response.errors || [])].map((e) =>
            typeof e === 'string' ? e : e.message,
          )
          return Observable.of(validationFailure(errors))
        } catch (e) {
          return Observable.of(validationFailure([intl.formatMessage({ id: 'ducks.server' })]))
        }
      }),
  )
}

export function sendAlertOnfailureEpic(action$) {
  return action$.ofType(VOUCHERS_FAILURE).mapTo(alertErrorDefault())
}

export function sendAlertOnVoucherSuccessEpic(action$) {
  return action$
    .ofType(VOUCHERS_SUCCESS)
    .mapTo(alertSuccess(intl.formatMessage({ id: 'ducks.vouchers.upload.success' })))
}
